import getOwaUserConfigurationOperation from 'owa-service/lib/operation/getOwaUserConfigurationOperation';
/**
 * Gets the new time zone offsets by getting the user configuration
 */
export default function getNewTimeZoneOffsets() {
    return getOwaUserConfigurationOperation().then(function (userConfiguration) {
        return userConfiguration.UserOptions.MailboxTimeZoneOffset;
    });
}
//# sourceMappingURL=getNewTimeZoneOffsets.js.map